import { combineReducers } from 'redux';
import {
  user,
  globalNavigation,
  notifications,
  userGroups,
  divisionsMasterList,
  advancedSearch,
  accountAssociateWidgetInformation,
  auditUserOptions,
} from '../modules/shell/reducers';
import clientsModule from '../modules/clients/reducers';
import clientingModule from '../modules/clienteling/reducers';
import performanceModule from '../modules/performance/reducers';
import globalSearch from '../modules/clients/reducers/globalSearch';
import associateNotifications from '../modules/notifications/reducers';
import productsModule from '../modules/products/reducers';
import recentProductSearch from '../modules/products/reducers/recentProductSearch';
import dismissFeatures from '../modules/home/reducers/newFeatures';
import getOrderStatuses from '../modules/home/reducers/homePage';
import generalManagerStores from '../modules/home/reducers/generalManagerStores';
import dateFilter from '../modules/performance/reducers/dateFilter';
import alterationsModule from '../modules/alterations/reducers';
import emailPreferences from '../modules/clienteling/reducers/emailPreferences';
import calendarRange from '../modules/performance/reducers/calendarRange';
import nonFilterPlpSelection from '../modules/products/reducers/nonFilterPlpSelection';
import gridListSortSelection from '../modules/clients/reducers/gridListSortSelection';
import memosModule from '../modules/memos/reducers';
import reservationsModule from '../modules/reservations/reducers';
import clientsGroupSelectedSort from '../modules/clients/reducers/clientGroupsSelectedSort';
import cartModule from '../modules/cart/reducers';
import looksModule from '../modules/looks/reducers';

const appReducer = combineReducers({
  user,
  clientsModule,
  clientingModule,
  performanceModule,
  productsModule,
  globalSearch,
  globalNavigation,
  advancedSearch,
  notifications,
  associateNotifications,
  userGroups,
  recentProductSearch,
  dismissFeatures,
  getOrderStatuses,
  generalManagerStores,
  dateFilter,
  alterationsModule,
  emailPreferences,
  calendarRange,
  nonFilterPlpSelection,
  gridListSortSelection,
  divisionsMasterList,
  memosModule,
  reservationsModule,
  clientsGroupSelectedSort,
  accountAssociateWidgetInformation,
  cartModule,
  auditUserOptions,
  looksModule,
});

export default (state, action) => appReducer(state, action);
